<template>
  <button v-if="showButton !== false" class="btn btn-error" @click="open_modal">
    <i class="fa-solid fa-trash"></i>
    Xóa
  </button>
  <dialog ref="dialogRef" class="modal" :open="open">
    <div class="modal-box">
      <h3 class="mb-4 text-lg font-bold">Xác nhận xóa máy trạm vĩnh viễn</h3>

      <div class="py-2">
        <div class="mb-1">
          Nhập <span class="font-bold">{{ agent?.computer_name }}</span> để xác
          nhận xóa vĩnh viễn máy trạm
        </div>
        <div class="w-full">
          <input class="input w-full" v-model="confirm_name" />
        </div>
      </div>

      <div class="modal-action">
        <form method="dialog" class="flex gap-2">
          <button class="btn" value="cancel">Hủy</button>
          <button
            class="btn btn-error min-w-28"
            @click="handle_confirm"
            :disabled="isDisabled"
          >
            <span v-if="deleteMutation.isIdle">Xác nhận xoá</span>
            <span v-else>Đang xóa...</span>
          </button>
        </form>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { deleteClient } from "@/api/clients";
import type { Client } from "@/types/clients";
import { useMutation } from "@tanstack/vue-query";
import { computed, onMounted, ref, watch } from "vue";
import type { client_detail } from "..";

interface Props {
  agent?: Client | client_detail;
  showButton?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showButton: true,
});

const open = defineModel<boolean>("open", { default: false });

const emit = defineEmits<{
  deleted: [];
}>();

const confirm_name = ref("");

const isDisabled = computed(
  () =>
    props.agent?.computer_name !== confirm_name.value ||
    deleteMutation.isPending.value,
);

const deleteMutation = useMutation({
  mutationFn: deleteClient,
  onSuccess: () => {
    emit("deleted");
    open.value = false;
  },
  onError: (error) => {
    console.error(error);
  },
});

const dialogRef = ref<HTMLDialogElement>();
const open_modal = () => {
  dialogRef.value?.showModal();
};

const handle_confirm = () => {
  if (!props.agent?.uuid || props.agent.computer_name !== confirm_name.value)
    return;

  deleteMutation.mutate(props.agent.uuid);
};

onMounted(() => {
  confirm_name.value = "";
});

watch(
  () => open.value,
  (newVal) => {
    if (newVal) {
      open_modal();
    }
  },
);
</script>
